var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPrintImrDisable(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1233_4589",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 37,
    height: 37
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.7052 0H0.0429688V36.6622H36.7052V0Z",
    fill: "url(#pattern0)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1233_4589)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.5783 -6.11035H-6.06836V42.0088H43.5783V-6.11035Z",
    fill: "#D7D7D7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1233_4589",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1233_4589",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAAB1UlEQVR4nO2cO04DQRAFJwLuANdy7MT9nGC4BlwM48hwCCBGJh80KSTsh+nudZXUsd+Un9peaXdLAQAAAAAAAACAX6xWqwtJj5LeJdXk82ZmD+1M4b7qFiyAoDrntDOVaCykyfWH6I8SDW8p+qcp0fAWIkT7y6LR8hfJ6lCMKdHwFqJzEQ0AAAAwjfV6fWVm92Z2kPTl/XdLcaa5eJZ0t9vtLidJ3mw2N5JeAxyqRh4ze2muRjcZyRoke1Sz27rwboryzW6M6EOA4DXZ7MeIPgUIXjNNczZYtHdoJR1EC9HVu4U0Wv7iWB3yl8qOFqKrd+NotPwlsTrkL5AdrVjDBYsQXb1buIhGlyQI0X1AdCcQ3QlEdwLRnUB0JxDdCUR3AtGdQHQnEN0JRHcC0Z1A9NJFz3XvXUmCZjirmX263U1azqvR+zEffIdoDW307WDR7e71dhc7jdZfRR9HvxqoPZcxVXZJgqatjON2u72eFKA1uz0y0PbPmB/IkgQNXxMnM3tq66LrS66WKrpEI03Q7PnTBM2eP03Q7PnTBM2eP03Q7PnTBM2eP03Q7PnTBM2ef+iVlZJMiYa3ECHaXxaNlr9IVodiTImGtxCdi2gAAAAAAIAyM99leSfST0OlsgAAAABJRU5ErkJggg=="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrintImrDisable);
export default __webpack_public_path__ + "static/media/printImrDisable.07c0c13603dc2d2749a6c70a6a0e3ac9.svg";
export { ForwardRef as ReactComponent };